// Shared playout item helpers — used by the GloboGraphics view (transport ControlBar)
// so the on-air ordering and the Take target are derived the same way the backend
// navigates the playlist.

// Playout order, mirroring the backend PlaylistNavigationService.flattenPlaylistItems:
// ungrouped (top-level) items first by num_ordem, then each story group in group
// order with its items by num_ordem. A flat num_ordem sort is WRONG for grouped
// (e.g. MOS) playlists, where each story numbers its items 1,2,3… independently —
// so "first published" must walk the grouped sequence, not the global num_ordem.
export function flattenGroupedItems(pl) {
  const items = pl?.items || [];
  if (!items.length) return [];
  const byOrdem = (a, b) => a.num_ordem - b.num_ordem;
  const grupos = [...(pl.grupos || [])].sort(byOrdem);
  const ungrouped = items.filter((i) => i.id_grupo == null).sort(byOrdem);
  const grouped = grupos.flatMap((g) => items.filter((i) => i.id_grupo === g.id_grupo).sort(byOrdem));
  const ordered = [...ungrouped, ...grouped];
  const seen = new Set(ordered.map((i) => i.id_playlist_item));
  const leftover = items.filter((i) => !seen.has(i.id_playlist_item)).sort(byOrdem);
  return [...ordered, ...leftover];
}

// Whether an item can be taken at all: it either already has an element in the
// sequencer, or carries a template one can be published from.
//
// Mirrors isTakeableItem on the API. Activation publishes only the head of a rundown
// and fills the rest behind its response, so "not published yet" is a timing state.
// Selecting on published-ness would step over the items the fill has not reached and
// hand the operator a later graphic than the one they asked for.
export function isItemTakeable(item) {
  if (!item) return false;
  if (item.cena?.dsc_mse_element_name || item.dsc_mse_element_name) return true;
  return !!(item.cena?.dsc_vizrt_template_id || item.dsc_vizrt_template_id);
}

// Broadcast semantic: re-take current on-air if any, else the first takeable item.
export function pickTakeTarget(pl) {
  const items = flattenGroupedItems(pl);
  return items.find((i) => i.flg_no_ar) || items.find(isItemTakeable) || null;
}
